import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Link } from '@calendly/ui/components/link'
import { BodyText, TitleText } from '@calendly/ui/components/typography'

import { CrudBookingExceptions } from 'features/event_type_editor'

import {
  sectionCss,
  sectionHeaderCss,
} from './styles'

const ConnectedCalendarsLink = ({ children }) => (
  <Link href="/app/availability/connected_calendars" rel="noopener noreferrer" target="_blank" underline={false}>
    {children}
  </Link>
)

export const BookingExceptionsSection = () => (
  <section className={sectionCss} data-testid="booking-exceptions-section">
    <div className={sectionHeaderCss}>
      <TitleText level={3} size="medium">
        {I18n.t('publisher.event_type_editor_crud.availability.booking_exceptions_title')}
      </TitleText>
      <BodyText color="muted" size="medium">
        {
          HtmlParser(
            I18n.t('publisher.event_type_editor_crud.availability.booking_exceptions_description'),
            { ConnectedCalendarsLink }
          )
        }
      </BodyText>
    </div>
    <CrudBookingExceptions variant="v4" />
  </section>
)
